const tokenPath = '/auth/token';
export default tokenPath;
